import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useStepper } from './hooks/useStepper';
import CustomStepIcon from './components/CustomStepIcon';
import StepperContent from './components/StepperContent';
import StepperControls from './components/StepperControls';
import background from '../../assets/img/background.png';
import { stepContents } from './hooks/contents';

const steps = ['Bienvenido', 'Términos y condiciones', 'Registro', 'Finalizado'];

const Register = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const {
    activeStep,
    isCheckboxChecked,
    setIsCheckboxChecked,
    handleNext,
    handleBack,
    handleReset,
    handleFinish,
    allStepsCompleted,
    step4Completed,
  } = useStepper({ stepsLength: steps.length });

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '100vh',
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      overflow: 'hidden',
    }}>
      <Box sx={{
        padding: '20px',
        backgroundColor: '#333',
        borderRadius: '3px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '850px',
        width: '100%',
        margin: '20px auto',
        textAlign: 'left',
        color: 'white',
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 40px)',
      }}>
        <Stepper activeStep={activeStep} sx={{ marginBottom: "20px" }}>
          {steps.map((label, index) => (
            <Step key={label} >
              <StepLabel StepIconProps={{
                  sx: {
                    "&. .MuiStepLabel-root .Mui-completed": {
                      background: "red",
                    }
                  }
                }}
                StepIconComponent={(props) => (
                  <CustomStepIcon
                    {...props}
                    color={index === activeStep ? "red" : "grey"}
                  />
                )}
              >
                <b style={{color: 'white'}}>{label}</b>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === 3 ? (
          <h2>Datos enviados con exito. Pulse para finalizar.</h2>
        ) : (
          <StepperContent
            stepIndex={activeStep}
            stepContents={stepContents}
            isCheckboxChecked={isCheckboxChecked}
            setIsCheckboxChecked={setIsCheckboxChecked}
            handleNext={handleNext}
            isFormSubmitted={isFormSubmitted}
            setIsFormSubmitted={setIsFormSubmitted}
          />
        )}
        <StepperControls
          activeStep={activeStep}
          handleNext={handleNext}
          handleBack={handleBack}
          handleReset={handleReset}
          stepsLength={steps.length}
          isCheckboxChecked={isCheckboxChecked}
          allStepsCompleted={allStepsCompleted}
          isFormSubmitted={isFormSubmitted}
        />
      </Box>
    </Box>
  );
};

export default Register;